import React from 'react';
import styles from './styles';
import FilterItem from '../../../OverviewContainer/EditableField';
import dataLogic from '../../Hooks/DataLogic';
import TsDsDisplay from './TsDsDisplay';
import TsDsEdit from './TsDsEdit';
import AgeEdit from './AgeEdit';
import {Loader} from '@xpertdox_js/xdcomponents';
import {colors} from '@xpertdox_js/xdstyle';
import HeaderObj from '../../../TrialUI/dataTableSettings';
import MsgBanner from '../../../msgBanner';

const Filters = props => {
  // console.log('========TrialOverview/Panels/Filters', props)

  //Treatment status, Disease stage state
  const [tsIncSelection, setTsIncSelection] = React.useState(props.data.ts_include ? {...props.data.ts_include} : {});
  const [tsExcSelection, setTsExcSelection] = React.useState(props.data.ts_exclude ? {...props.data.ts_exclude} : {});
  const [dsIncSelection, setDsIncSelection] = React.useState(props.data.ds_include ? {...props.data.ds_include} : {});
  const [dsExcSelection, setDsExcSelection] = React.useState(props.data.ds_exclude ? {...props.data.ds_exclude} : {});
  const [refreshState, setRefreshState] = React.useState(0);
  const headerObj = HeaderObj.headers;

  const ageOptions = () => {
    let min = 1, max = 75;
    let optionsArray = ['<1'];
    for(let i = min; i <= max; i++){
      optionsArray.push(i.toString())
    }
    optionsArray.push('>75')
    return optionsArray
  }


  // handle state update for treatementSTatus and diseaseStage
  const handleTsDsSelection = (dataType, filterType, valueObject) => {
    let setter, currentValue;
    if (dataType === 'ts')  {
      setter = filterType === 'inc' ? setTsIncSelection : setTsExcSelection;
      currentValue = filterType === 'inc' ? tsIncSelection : tsExcSelection;
    } else if (dataType === 'ds') {
      setter = filterType === 'inc' ? setDsIncSelection : setDsExcSelection;
      currentValue = filterType === 'inc' ? dsIncSelection : dsExcSelection;
    }
    setter({
      ...currentValue,
      ...valueObject,
    })
  }

  let ageParsed = dataLogic.parseAge(props.data.age);
  const genderValue = Array.isArray(props.data.filterGender)
    ? props.data.filterGender.join(', ')
    : props.data.filterGender === 'All' ? 'M, F' : props.data.filterGender;

  const handleEcog = (value) => {
    let valArr = [];
    value.forEach(val => {
      valArr.push(parseInt(val));
    })
    return (!valArr || valArr.length === 0) ? 4 : Math.max.apply(null, valArr);
  }

  const content = [
    {
      title: props.nct,
      diffProperty: 'customTitle',
      value: props.data.customTitle || props.data.title,
      editedLogs: props.editedLogs ? props.editedLogs['customTitle'] : false,
      formSettings: [{
        type: 'text',
        value: props.data.customTitle || props.data.title,
      }],
      tooltip: ''
    },
    {
      title: 'Minimum Age (Years)',
      diffProperty: 'minAge',
      value: props.data.minAge || ageParsed.minAge || '',
      valueToCompare: props.diff.maxAge || props.data.maxAge || ageParsed.maxAge || '',
      editedLogs: props.editedLogs ? props.editedLogs['minAge'] : false,
      SubComponent: ({handleSubmit, handleHeight, subComponentStyles, formState, setFormState, setManualHasChanged}) => (<AgeEdit
          id="minAge"
          handleSubmit={handleSubmit}
          formState={formState}
          setManualHasChanged={setManualHasChanged}
          setFormState={setFormState}
          handleHeight={handleHeight}
          setDiff={props.setDiff}
          styles={subComponentStyles}
          title="Months"
          value={props.data.minAgeDisplay}
      />),
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'eligibility', 'minimum_age'),
        type: 'select',
        holdCallBack: true,
        value:  props.data.minAge || ageParsed.minAge || '',
        options: ageOptions( props.diff.maxAge || props.data.maxAge || ageParsed.maxAge, 'min')
      }],
      tooltip: headerObj.minimumAge.tip
    },
    {
      title: 'Maximum Age (Years)',
      diffProperty: 'maxAge',
      value: props.data.maxAge || ageParsed.maxAge || '',
      valueToCompare: props.diff.minAge || props.data.minAge || ageParsed.minAge || '',
      editedLogs: props.editedLogs ? props.editedLogs['maxAge'] : false,
      SubComponent: ({handleSubmit, handleHeight, subComponentStyles, formState, setFormState, setManualHasChanged}) => (<AgeEdit
          id="maxAge"
          handleSubmit={handleSubmit}
          formState={formState}
          setFormState={setFormState}
          setManualHasChanged={setManualHasChanged}
          handleHeight={handleHeight}
          setDiff={props.setDiff}
          styles={subComponentStyles}
          title="Months"
          value={props.data.maxAgeDisplay}
      />),
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'eligibility', 'maximum_age'),
        type: 'select',
        holdCallBack: true,
        value: props.data.maxAge || ageParsed.maxAge || '',
        options: ageOptions( props.diff.minAge ||  props.data.minAge || ageParsed.minAge, 'max')
      }],
      tooltip: headerObj.maximumAge.tip
    },
    {
      title: 'Gender',
      diffProperty: 'gender',
      value: genderValue,
      editedLogs: props.editedLogs ? props.editedLogs['gender'] : false,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'gender'),
        type: 'select',
        value: props.diff.gender || genderValue,
        options: [['Male', 'M'], ['Female', 'F'], ['All', 'M, F']]
        // options: []
      }],
      formatDisplay: value => (
        value === 'M' ? 'Male'
        : value === 'F' ? 'Female'
        : value === 'M, F' ? 'All'
        : value
      ),
      tooltip: headerObj.gender.tip
    },
    {
      title: 'Phase',
      diffProperty: 'phase',
      value: props.data.phase,
      formatDisplay: value => {
        if(Array.isArray(value)) return value.join(', ')
        else return value
      },
      editedLogs: props.editedLogs ? props.editedLogs['phase'] : false,
      formSettings: [{
        type: 'multiselect',
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'phase'),
        value: props.diff.phase || props.data.phase,
        options: ['Phase 1', 'Phase 2', 'Phase 3', 'Phase 4']
      }],
      tooltip: 'Select the study phase'
    },
    {
      title: 'Enrolling Healthy Volunteers',
      diffProperty: 'healthyVolunteers',
      value: props.data.healthyVolunteers,
      formatDisplay: value => {
          return value === 'hv_yes' ? 'Yes'
          : value === 'hv_no' ? 'No'
          : value
      },
      editedLogs: props.editedLogs ? props.editedLogs['healthy_volunteers'] : false,
      formSettings: [{
        type: 'radio',
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'healthy_volunteers'),
        value: props.data.healthyVolunteers,
        options: [['Yes', 'Yes'], ['No', 'No']]
      }],
      tooltip: headerObj.healthyVolunteer.tip
    },
    {
      title: 'Primary Purpose',
      diffProperty: 'primaryPurpose',
      value:  props.data.primary_purpose,
      editedLogs: props.editedLogs ? props.editedLogs['primary_purpose'] : false,
      formSettings: [{
        type: 'select',
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'primary_purpose'),
        value: props.data.primary_purpose,
        options: props.filters.primary_purpose
      }],
      tooltip: headerObj.primaryPurpose.tip
    },
    {
      title: 'Eligible ECOG Status',
      diffProperty: 'pscore',
      value: props.data.pscore && handleEcog(props.data.pscore) || '',
      formatDisplay: (value) => {
        if (value) {
          let displayValue = '0';
          let newValue;
          if (Array.isArray(value)) newValue = handleEcog(value);
          else newValue = value;
          const parsedValue = parseInt(newValue);
          if (parsedValue > 0) displayValue += ', 1';
          if (parsedValue > 1) displayValue += ', 2';
          if (parsedValue > 2) displayValue += ', 3';
          if (parsedValue > 3) displayValue += ', 4';
          return displayValue;
        } else {
          return value;
        }
      },
      editedLogs: props.editedLogs ? props.editedLogs['p_score'] : false,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'p_score'),
        type: 'select',
        value: props.diff.pscore || props.data.pscore,
        options: [['0', 1],['1', 1], ['2', 2], ['3', 3], ['4', 4]],
      }],
      tooltip: 'Select the maximum ECOG status of an eligible patient'
    },
    {
      title: 'Eligible  Mutations',
      diffProperty: 'mutationsIN',
      value:  props.data.mutationsIN,
      formatDisplay: (value) => {
        if(Array.isArray(value)) return value.join(', ')
        else return value
      },
      valueToCompare: props.diff.mutationsOUT || props.data.mutationsOUT || [],
      editedLogs: props.editedLogs ? props.editedLogs['mutationsIN'] : false,
      formSettings: [{
        type: 'multiselect',
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'mutations', 'include'),
        value: props.diff.mutationsIN || props.data.mutationsIN,
        options: props.filters.mutations,
      }],
      tooltip: headerObj.mutationsIn.tip
    },
    {
      title: 'Ineligible Mutations',
      diffProperty: 'mutationsOUT',
      value:  props.data.mutationsOUT,
      formatDisplay: (value) => {
        if(Array.isArray(value)) return value.join(', ')
        else return value
      },
      editedLogs: props.editedLogs ? props.editedLogs['mutationsOUT'] : false,
      valueToCompare: props.diff.mutationsIN || props.data.mutationsIN || [],
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'mutations', 'exclude'),
        type: 'multiselect',
        value: props.diff.mutationsOUT || props.data.mutationsOUT,
        options: props.filters.mutations
      }],
      tooltip: headerObj.mutationsOut.tip
    },
    {
      title: 'Treatment Status Inclusion Criteria',
      diffProperty: 'ts_include',
      editedLogs: props.editedLogs ? props.editedLogs['ts_include'] : false,
      editedLogsProps: {
        type:'inc',
        dataType:'ts',
        options: props.filters.treatment_status,
        incState:{value: tsIncSelection,  setter:setTsIncSelection},
        excState:{value:tsExcSelection,  setter:setTsExcSelection}
      },
      value: props.data.ts_include || undefined,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'ts_include'),
        customUpdateBtn: true
      }],
      clearChangesCallback: () => setTsIncSelection(props.data.ts_include || {}),
      customDisplayField: () => (<TsDsDisplay
        type='inc'
        dataType='ts'
        options={props.filters.treatment_status}
        data={props.data.ts_include}
        incState={{value: tsIncSelection,  setter:setTsIncSelection}}
        excState={{value:tsExcSelection,  setter:setTsExcSelection}}
      />),
      customEditField: ({handleSubmit, handleHeight}) => (<TsDsEdit
        setRefreshState={setRefreshState}
        handleHeight={handleHeight}
        refreshState={refreshState}
        type='inc'
        dataType='ts'
        options={props.filters.treatment_status}
        data={props.data.ts_include}
        incState={{value:tsIncSelection,  setter:setTsIncSelection}}
        excState={{value:tsExcSelection,  setter:setTsExcSelection}}
        handleSubmit={handleSubmit}
        handleSelection={handleTsDsSelection}
      />),
      tooltip: headerObj.treatmentStatusInclude.tip
    },
    {
      title: 'Treatment Status Exclusion Criteria',
      diffProperty: 'ts_exclude',
      editedLogs: props.editedLogs ? props.editedLogs['ts_exclude'] : false,
      value: props.data.ts_exclude || undefined,
      editedLogsProps: {
        type:'exc',
        dataType:'ts',
        options: props.filters.treatment_status,
        incState:{value: tsIncSelection,  setter:setTsIncSelection},
        excState:{value:tsExcSelection,  setter:setTsExcSelection}
      },
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'ts_exclude'),
        customUpdateBtn: true
      }],
      clearChangesCallback: () => setTsExcSelection(props.data.ts_exclude || {}),
      customDisplayField: () => (<TsDsDisplay
        type='exc'
        dataType='ts'
        options={props.filters.treatment_status}
        data={props.data.ts_exclude}
        incState={{value: tsIncSelection, setter: setTsIncSelection}}
        excState={{value: tsExcSelection, setter: setTsExcSelection}}
      />),
      customEditField: ({handleSubmit, handleHeight}) => (<TsDsEdit
        setRefreshState={setRefreshState}
        handleHeight={handleHeight}
        refreshState={refreshState}
        type='exc'
        dataType='ts'
        options={props.filters.treatment_status}
        data={props.data.ts_exclude}
        incState={{value: tsIncSelection, setter: setTsIncSelection}}
        excState={{value: tsExcSelection, setter: setTsExcSelection}}
        handleSubmit={handleSubmit}
        handleSelection={handleTsDsSelection}
      />),
      tooltip: headerObj.treatmentStatusExclude.tip
    },
    {
      title: 'Disease Stage Inclusion Criteria',
      diffProperty: 'ds_include',
      value: props.data.ds_include || undefined,
      editedLogs: props.editedLogs ? props.editedLogs['ds_include'] : false,
      defaultValue: dataLogic.getDefaultValue(props.data.default, 'ds_include'),
      formSettings: [{
        customUpdateBtn: true
      }],
      editedLogsProps: {
        type:'inc',
        dataType:'ds',
        options: props.filters.disease_stage,
        incState:{value: dsIncSelection,  setter:setDsIncSelection},
        excState:{value:dsExcSelection,  setter:setDsExcSelection}
      },
      clearChangesCallback: () => setDsIncSelection(props.data.ds_include || {}),
      customDisplayField: () => (<TsDsDisplay
        type='inc'
        dataType='ds'
        options={props.filters.disease_stage}
        data={props.data.ds_include}
        incState={{value: dsIncSelection, setter: setDsIncSelection}}
        excState={{value: dsExcSelection, setter: setDsExcSelection}}
      />),
      customEditField: ({handleSubmit, handleHeight}) => (<TsDsEdit
        setRefreshState={setRefreshState}
        handleHeight={handleHeight}
        refreshState={refreshState}
        type='inc'
        dataType='ds'
        options={props.filters.disease_stage}
        data={props.data.ds_include}
        incState={{value: dsIncSelection, setter: setDsIncSelection}}
        excState={{value: dsExcSelection, setter: setDsExcSelection}}
        handleSubmit={handleSubmit}
        handleSelection={handleTsDsSelection}
      />),
      tooltip: headerObj.diseaseStageInclude.tip
    },
    {
      title: 'Disease Stage Exclusion Criteria',
      diffProperty: 'ds_exclude',
      editedLogs: props.editedLogs ? props.editedLogs['ds_exclude'] : false,
      formSettings: [{
        defaultValue: dataLogic.getDefaultValue(props.data.default, 'ds_exclude'),
        customUpdateBtn: true
      }],
      editedLogsProps: {
        type:'exc',
        dataType:'ds',
        options: props.filters.disease_stage,
        incState:{value: dsIncSelection,  setter:setDsIncSelection},
        excState:{value:dsExcSelection,  setter:setDsExcSelection}
      },
      value: props.data.ds_exclude || undefined,
      clearChangesCallback: () => setDsExcSelection(props.data.ds_exclude || {}),
      customDisplayField: () => (<TsDsDisplay
        type='exc'
        dataType='ds'
        options={props.filters.disease_stage}
        data={props.data.ds_exclude}
        incState={{value: dsIncSelection, setter: setDsIncSelection}}
        excState={{value: dsExcSelection, setter: setDsExcSelection}}
      />),
      customEditField: ({handleSubmit, handleHeight}) => (<TsDsEdit
        setRefreshState={setRefreshState}
        handleHeight={handleHeight}
        refreshState={refreshState}
        type='exc'
        dataType='ds'
        options={props.filters.disease_stage}
        data={props.data.ds_exclude}
        incState={{value: dsIncSelection, setter: setDsIncSelection}}
        excState={{value: dsExcSelection, setter: setDsExcSelection}}
        handleSubmit={handleSubmit}
        handleSelection={handleTsDsSelection}
      />),
      tooltip: headerObj.diseaseStageExclude.tip
    },
  ]

  return(
    <div style={styles.container}>
      <MsgBanner type='editField' removable user={props.user}/>
      <MsgBanner type='trialFilters' user={props.user} customColor={{text: 'white', background: colors.errorAlt}}/>
      <div style={styles.editPanel}>
        {props.filters && Object.keys(props.filters).length > 0
          ? content.map((settings, i) => <FilterItem
              setValue={props.setDiff}
              key={i}
              index={i}
              length={content.length - 1}
              diff={props.diff[settings.diffProperty]}
              settings={settings}
              zIndex={content.length - i}
              width={props.width}
            />)
          : <div style={styles.loaderContainer}>
              <Loader
                width='100px'
                height='100px'
                noBg
              />
            </div>
        }
      </div>
    </div>
  )
}

export default Filters;
